import UsersBaseController from '../common/users.base.controller'

class UsersallController extends UsersBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, UsersService,CommonLayoutService, $translate, $stateParams, $scope, $window, $location) {

    super(Auth, $state, User, UsersService, Modal, $translate, $stateParams, $location)

    this.$state = $state;
    this.$window = $window
    this.UsersService = UsersService;
    this.CommonLayoutService = CommonLayoutService;
    this.id = 'users.all'
    this.loading = true
    this.users = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = {}
    this.searchText = ''
    this.User = User;
    this.hasUserEditPermission = true;
    this.hasBulkUpdateUserPermission = true;
    this.branch = User.getUser().branchId,
      this.loggedInUser = User.getUser().id,
      this.leader = {};
    this._status = 'all'
    this.userStatus = [{
      label: 'All',
      value: 'all'
    },
    // {
    //   label: 'Active',
    //   value: 'active'
    // }, {
    //   label: 'Inactive',
    //   value: 'inactive'
    // }, 
    {
      label: this.$translate.instant('users.webUser'),
      value: 'web'
    }, {
      label: this.$translate.instant('users.handheldUser'),
      value: 'hht'
    }, {
      label: this.$translate.instant('users.service_user'),
      value: 'serviceUser'
    }, {
      label: this.$translate.instant('users.customer_user'),
      value: 'customerUser'
    }, {
      label: this.$translate.instant('users.supervisor'),
      value: 'supervisor'
    }
    ]
    this.$location = $location;
    this.userStats = 'active';
    this.filterByValue = null;
    this.model.filterByAllBranch = false;
  }

  isMe(id) {
    return id === this.User.getUser().id
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData();
    this.UsersService.validateUserPermissions(this.User.getUser().firstName, this.User.getUser().lastName).then((permission) => {
      this.hasUserEditPermission = (permission.hasUserEditPermission || this.CommonLayoutService.isAllowToAccessPages()); 
      this.hasBulkUpdateUserPermission = (permission.hasBulkUpdateUserPermission || this.CommonLayoutService.isAllowToAccessPages());
    })
    // this.userLogEntry();
  }

  edit(user) {
    this.$state.go('users.edit', ({
      id: user.id
    }))
  }

  delete(user) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${user.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(user.id, this.branch)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close();
            this.refresh();
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  loadData() {
    const searchObj = this.generateSearchObj();

    this.loading = true;
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total
        this.loading = false
        this.users = data.results;
        this.userInfo = data;
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }

  generateSearchObj() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.branch
          }
        ],
        operator: 'AND'
      }
    };

    if (this.searchText) {
      const searchFields = ['firstName', 'lastName', 'id'];
      const trimmedSearchText = this.searchText.trim();
      let searchWords = trimmedSearchText
        .split(/[^a-zA-Z0-9]+/)
        .filter((word) => /[a-zA-Z0-9]/.test(word));

      if (!searchWords.length && trimmedSearchText) {
        searchWords = [trimmedSearchText];
      }

      if (searchWords.length) {
        searchObj.queryJSON.rules.push({
          group: {
            operator: 'AND',
            rules: searchWords.map((word) => ({
              group: {
                operator: 'OR',
                rules: searchFields.map((field) => ({
                  field,
                  condition: 'like',
                  data: `%${word}%`
                }))
              }
            }))
          }
        });
      }
    }

    switch (this._status) {
      // case 'active': {
      //   searchObj.queryJSON.rules.push({
      //     field: 'disabled',
      //     condition: '=',
      //     data: false
      //   });
      //   break;
      // }
      // case 'inactive': {
      //   searchObj.queryJSON.rules.push({
      //     field: 'disabled',
      //     condition: '=',
      //     data: true
      //   });
      //   break;
      // }
      case 'web': {
        searchObj.queryJSON.rules.push({
          field: 'email',
          condition: '!=',
          data: null
        });
        break;
      }
      case 'hht': {
        searchObj.queryJSON.rules.push({
          // field: 'email',
          // condition: '=',
          // data: null
          field: 'downloadToHHT',
          condition: '=',
          data: true
        });
        break;
      }
      case 'serviceUser': {
        searchObj.queryJSON.rules.push({
          field: 'serviceUser',
          condition: '=',
          data: true
        });
        break;
      }
      case 'customerUser': {
        searchObj.queryJSON.rules.push({
          field: 'customerUser',
          condition: '=',
          data: true
        });
        break;
      }
      case 'supervisor': {
        searchObj.queryJSON.rules.push({
          field: 'supervisor',
          condition: '=',
          data: true
        });
        break;
      }
    }

    switch (this.userStats) {
      case 'active': {
        searchObj.queryJSON.rules.push({
          "group": {
            "rules": [
              {
                "field": 'downloadToHHT',
                "condition": '=',
                "data": true
              },
              {
                "field": 'email',
                "condition": '!=',
                "data": null
              },
              {
                "field": 'supervisor',
                "condition": '=',
                "data": true
              },
              {
                "field": 'serviceUser',
                "condition": '=',
                "data": true
              }
            ],
            "operator": "OR"
          }
        });
        break;
      }
      case 'inactive': {
        searchObj.queryJSON.rules.push(
          {
            field: 'downloadToHHT',
            condition: '=',
            data: false
          },
          {
            field: 'email',
            condition: '=',
            data: null
          },
          {
            field: 'supervisor',
            condition: '=',
            data: false
          },
          {
            field: 'serviceUser',
            condition: '=',
            data: false
          });
        break;
      }
    }

    searchObj.extraDetails = {
      searchText: this.searchText,
      status: this._status,
      branchId: this.branch,
      filterByAllBranch: this.model.filterByAllBranch
    }

    return searchObj;
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData();
  }

  toggleExpand(user) {
    user.expand = !user.expand;
  }

  userLogEntry() {
    this.Service.getLatestLogEntry(this.loggedInUser)
      .then((logs) => {
        this.lastLoginDate = logs && logs.createdAt ? logs.createdAt : null;
        this.lastLoginSource = logs && logs.entryData ? logs.entryData.loginSource : null;
        this.userId = logs.userId;
      })
      .catch((err) => {
        console.log(err);
      })
  }

  getUserStats(value) {
    // this._status = 'all';
    this.page = 1;
    this.userStats = this.userStats === value ? undefined : value;
    const id = value === 'active' ? 'active-user' : 'inactive-user';
    document.getElementById(id).blur();
    this.loadData();
  }

  filterByBranch(value) {
    this.page = 1;
    this.filterByValue = this.filterByValue === value ? undefined : value;
    this.model.filterByAllBranch = this.filterByValue ? true : false;
    this.loadData();
  }

  updateCustomerUserPermissions() {
    this.updatingCustomerUserPermissions = true;
    this.UsersService.updateCustomerUserPermissions()
      .then((res) => {
        this.Modal.confirm({
          header: this.$translate.instant('successModal.title'),
          message: this.$translate.instant('Customer Users, Branch, password and permissions updated.'),
          callback: (({ modal }) => {
            modal.close();
          }),
          buttons: ['common.ok'],
          type: 'success'
        });
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.updatingCustomerUserPermissions = false;
      })
  }

  bulkUpdateUserPermissions() {
    this.Modal.bulkUpdateUserPermissionsModal(
      (payload) => {
        if (!payload) return;
        this.updatingCustomerUserPermissions = true;
        this.UsersService.bulkUpdateCustomerUsers(payload)
          .then(() => {
            const msg = payload.isCustomerUser
              ? 'Customer user details update successfully.'
              : 'Web user details update successfully.';
            this.Modal.confirm({
              header: this.$translate.instant('successModal.title'),
              message: this.$translate.instant(msg),
              callback: (({ modal }) => {
                modal.close();
                this.refresh();
              }),
              buttons: ['common.ok'],
              type: 'success'
            });
          })
          .catch((err) => {
            this.Modal.alert({
              header: 'Error',
              message: err.data ? err.data.message : err.message || 'An error occurred',
              type: 'danger'
            });
          })
          .finally(() => {
            this.updatingCustomerUserPermissions = false;
          });
      },
      () => { },
      this.branch
    );
  }
}

export default UsersallController;



// WEBPACK FOOTER //
// ./client/app/components/users/all/users.all.controller.js